import React from 'react';
import { Typography } from '@material-ui/core';

import Sante24Hero from '../../../../../../../images/test-assignment-sante24-hero-it.png';

const IT = () => (
  <>
    <img
      src={Sante24Hero}
      alt="Order your assigned test"
      className="sidebar__image"
    />
    <div className="sidebar__main-content">
      <Typography variant="body2">
        <br />
        <br />
        Il <b>santé24</b> ti ha assegnato un test di laboratorio da effettuare a
        casa.
        <br />
        <br />
        Ti preghiamo di seguire questi passaggi:
        <br />
        <br />
        <b>1. Ordina il test</b>
        <br />
        Clicca sul pulsante &quot;Ordina&quot; alla fine di questa e-mail e
        segui le istruzioni per completare l’ordine.
        <br />
        <br />
        <b>Nota bene:</b> Al momento del pagamento ti verranno addebitati CHF
        33.00 per la spedizione e i materiali. Si tratta di una prestazione a
        carico del paziente. Il rimborso tramite l’assicurazione di base non è
        possibile. I costi dell’analisi verranno addebitati direttamente alla
        tua assicurazione di base. Se non hai ancora raggiunto la franchigia,
        l’assicurazione di base ti invierà una fattura per i costi
        corrispondenti.
        <br />
        <br />
        <b>2. Esegui comodamente il test a casa</b>
        <br />
        1-2 giorni lavorativi dopo l’ordine, riceverai il tuo kit di test in una
        busta discreta tramite posta. Il kit contiene un codice di attivazione,
        tutto il materiale necessario e istruzioni chiare per il prelievo del
        campione. Dopo aver effettuato il prelievo, inserisci il campione nella
        scatola di ritorno fornita e imbucala in una qualsiasi cassetta postale
        della Posta Svizzera.
        <br />
        <br />
        <b>3. Ricevi i risultati</b>
        <br />
        Il tuo campione sarà analizzato da Medisyn, un prestigioso fornitore di
        laboratori svizzeri. Una volta pronti i risultati, riceverai una
        chiamata da santé24 per discuterne. Dopo la chiamata, i risultati
        saranno resi disponibili online.
      </Typography>
      <button type="button" className="sidebar__button">
        Ordina il test assegnato
      </button>
      <Typography variant="body2">
        Se hai domande, puoi contattarci in qualsiasi momento all’indirizzo:
        service@yourself.health
      </Typography>
    </div>
    <div className="sidebar__footer">
      <Typography variant="body2">
        Health Yourself
        <br />
        <br />
        Lerchenfeldstrasse 3, 9014 St. Gallen, Switzerland
        <br />
        <br />
        Non vuoi più ricevere queste e-mail? Annulla l’iscrizione
        <br />
        <br />© 2025 Health Yourself
      </Typography>
    </div>
  </>
);

export default IT;
